import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { setCurrentPage } from "../../redux/Slice/Dashboard/leftNavSlice";
import { fetchUserPermissions } from "../../redux/Slice/User/userDetailsSlice";
import AiSettings from "../../components/Settings/Features/AiSettings.jsx";

function AiSettingsPage() {
  const dispatch = useDispatch();
  const { accountid } = useParams();
  const subscriptionFeatures = useSelector((state) => state.subscription?.features);

  useEffect(() => {
    dispatch(fetchUserPermissions());
    dispatch(setCurrentPage("AI Agents"));
  }, [dispatch]);

  // Fail-open while features haven't loaded yet, same convention as the
  // LeftNav/BottomNav AI item gating — only block once we know for sure.
  const aiFeatureEnabled =
    subscriptionFeatures == null ||
    subscriptionFeatures.length === 0 ||
    subscriptionFeatures.find((f) => f.key === "aiAssistants")?.enabled !== false;

  if (!aiFeatureEnabled) {
    return <Navigate to={`/home/${accountid}`} replace />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AiSettings />
      </Box>
    </Box>
  );
}

export default AiSettingsPage;
